import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'

import { USERS_ONLINE } from './UsersOnline.queries'

const UsersOnline = () => {
    const { t } = useTranslation()
    const { data } = useQuery<any>(USERS_ONLINE)

    if (!data?.site) {
        return null
    }

    return (
        <div className="users-online ___grey">
            <span>
                {t('widget-users-online.nr-online', {
                    count: data.site.usersOnline,
                })}
            </span>
        </div>
    )
}

export default UsersOnline
